/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Completedat1Inputs */

const en__field_completedat1 = /** @type {(inputs: _Field_Completedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed at`)
};

/**
* | output |
* | --- |
* | "Completed at" |
*
* @param {_Field_Completedat1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_completedat1 = /** @type {((inputs?: _Field_Completedat1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Completedat1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_completedat1(inputs)
});
export { _field_completedat1 as "_field_completedAt" }